// Import model
import { StartEstimateSetDiscountRequest } from '../models/StartEstimateSetDiscountRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartEstimateSetDiscountRequest - handles JSON serialization and deserialization with type validation
 */
export class StartEstimateSetDiscountRequestSerializer {
  /**
   * Deserializes a JSON string into a StartEstimateSetDiscountRequest instance
   */
  static deserialize(json: string): StartEstimateSetDiscountRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartEstimateSetDiscountRequest instance
   */
  static fromObject(obj: any): StartEstimateSetDiscountRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartEstimateSetDiscountRequest');
    }


    const instance: StartEstimateSetDiscountRequest = {
      sales: obj['sales'] as number | undefined,
      service: obj['service'] as number | undefined,
      salesAmount: obj['salesAmount'] as number | undefined,
      serviceAmount: obj['serviceAmount'] as number | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartEstimateSetDiscountRequest instances
   */
  static deserializeArray(json: string): StartEstimateSetDiscountRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartEstimateSetDiscountRequest instance to a JSON string
   */
  static serialize(instance: StartEstimateSetDiscountRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartEstimateSetDiscountRequest instance to a plain object
   */
  static toObject(instance: StartEstimateSetDiscountRequest): any {
    return {
      'sales': instance.sales,
      'service': instance.service,
      'salesAmount': instance.salesAmount,
      'serviceAmount': instance.serviceAmount,
    };
  }

  /**
   * Serializes an array of StartEstimateSetDiscountRequest instances to a JSON string
   */
  static serializeArray(instances: StartEstimateSetDiscountRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
